import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./AdminPedidos.css";

const API = process.env.REACT_APP_API_URL;

export default function AdminPedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [devoluciones, setDevoluciones] = useState([]);
  const [totalUsuarios, setTotalUsuarios] = useState(0);
  const [estadosTemp, setEstadosTemp] = useState({});
  const [cargando, setCargando] = useState(true);

  const estadosPago = [
    "CANCELADO", "DEVUELTO", "ENTREGADO", "ENVIADO",
    "EN_PREPARACION", "PAGADO", "PARCIAL_DEVUELTO", "PENDIENTE_PAGO"
  ];

  // --- FUNCIÓN DE RENOVACIÓN ---
  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch(API + "/user/refresh", {
        method: "POST",
        credentials: "include" 
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        console.log("✅ Token renovado con éxito");
        return true;
      }
    } catch (error) {
      console.error("❌ Error crítico al renovar token:", error);
    }
    return false;
  };

  // --- CARGAR TOTAL DE USUARIOS ---
  const cargarTotalUsuarios = async (intento = 0) => {
    const tokenActual = localStorage.getItem("token");
    try {
      const res = await fetch(API + "/user/totalUsuario", {
        headers: { "Authorization": `Bearer ${tokenActual}` },
        credentials: "include"
      });

      if (res.status === 403 && intento < 1) {
        const renovado = await renovarToken();
        if (renovado) return cargarTotalUsuarios(1);
        return;
      }

      if (res.ok) {
        const data = await res.json();
        setTotalUsuarios(data.total - 1 || 0);
      }
    } catch (error) {
      console.error("Error al cargar total usuarios:", error);
    }
  };

  // --- CARGAR PEDIDOS ---
  const cargarPedidos = async (intento = 0) => {
    const tokenActual = localStorage.getItem("token");
    try {
      const res = await fetch(API + "/pedido/traerPedidosPagados", {
        headers: { "Authorization": `Bearer ${tokenActual}` },
        credentials: "include"
      });

      if (res.status === 403 && intento < 1) {
        const renovado = await renovarToken();
        if (renovado) return cargarPedidos(1); 
        return;
      }

      const data = await res.json();
      const lista = data.datos || [];
      setPedidos(lista);

      const iniciales = {};
      lista.forEach(p => iniciales[p.id] = p.estado);
      setEstadosTemp(iniciales);
    } catch (error) {
      console.error("Error al cargar pedidos:", error);
    } finally {
      setCargando(false);
    }
  };

  // --- TRAER DEVOLUCIONES ---
  const traerDevoluciones = async (intento = 0) => {
    const tokenActual = localStorage.getItem("token");
    try {
      const res = await fetch(API + "/devolucion/traerTodasDevoluciones", {
        headers: { "Authorization": `Bearer ${tokenActual}` },
        credentials: "include"
      });

      if (res.status === 403 && intento < 1) {
        const renovado = await renovarToken();
        if (renovado) return traerDevoluciones(1);
        return;
      }

      if (res.ok) {
        const data = await res.json();
        setDevoluciones(data.datos || []);
      }
    } catch (error) {
      console.error("Error al cargar devoluciones:", error);
    }
  };

  // --- ACTUALIZAR ESTADO DEL PEDIDO ---
  const actualizarEstado = async (pedidoId, intento = 0) => {
    const nuevoEstado = estadosTemp[pedidoId];
    if (!nuevoEstado) return;

    const tokenActual = localStorage.getItem("token");

    try {
      const res = await fetch(`${API}/pedido/actualizarPedidoEstado/${pedidoId}/${nuevoEstado}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${tokenActual}`,
          "Content-Type": "application/json"
        },
        credentials: "include"
      });

      if (res.status === 403 && intento < 1) {
        const renovado = await renovarToken();
        if (renovado) return actualizarEstado(pedidoId, 1);
        return;
      }

      if (res.ok) {
        alert("✅ Estado actualizado con éxito");
        cargarPedidos(); 
      } else {
        alert("❌ Error al actualizar el estado");
      }
    } catch (error) {
      console.error("Error al actualizar:", error);
      alert("❌ Error de conexión");
    }
  };

  useEffect(() => {
    const inicializar = async () => {
        await cargarPedidos();
        await traerDevoluciones();
        await cargarTotalUsuarios();
    }
    inicializar();
  }, []);

  return (
    <div className="admin-view">
      <header className="admin-hero">
        <div className="container">
          <NavLink to="/" className="btn-back">← Volver al inicio</NavLink>
          <h1>🧑‍💼 Panel de Gestión</h1>
          <p>Control de pedidos y flujo de logística de Mundo Shop</p>
        </div>
      </header>

      <main className="container admin-content">
        <section className="stats-summary">
          <div className="stat-card">
            <span className="stat-value">{pedidos.length}</span>
            <span className="stat-label">Pedidos Totales</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">{devoluciones.length}</span>
            <span className="stat-label">Devoluciones</span>
          </div>
          <div className="stat-card">
            <span className="stat-value">{totalUsuarios}</span>
            <span className="stat-label">Usuarios Registrados</span>
          </div>
        </section>

        <h3 className="list-title">Lista de Pedidos Recientes</h3>

        <div className="pedidos-grid-admin">
          {cargando ? (
            <div className="loader">Cargando gestión de pedidos...</div>
          ) : (
            pedidos.map((pedido) => {
              const dev = devoluciones.find((d) => d.pedidoId === pedido.id);
              return (
                <div className={`pedido-card-admin ${pedido.estado.toLowerCase()}`} key={pedido.id}>
                  <div className="card-section-header">
                    <div>
                      <span className="id-tag">#{pedido.id}</span>
                      <h4>{pedido.userDTO?.nombre || "Cliente General"}</h4>
                    </div>
                    <div className={`status-pill ${pedido.estado}`}>
                      {pedido.estado.replace("_", " ")}
                    </div>
                  </div>

                  <div className="card-section-body">
                    <div className="info-row">
                      <strong>📍 Dirección:</strong> <span>{pedido.direccionEnvio}</span>
                    </div>
                    <div className="info-row">
                      <strong>💰 Total:</strong> <span className="price-text">${pedido.total?.toLocaleString("es-CO")}</span>
                    </div>

                    <div className="mini-products-list">
                      <h6>Productos:</h6>
                      {pedido.detalles?.map((det) => (
                        <div key={det.id} className="mini-product-item">
                          <span>{det.nombreProducto}</span>
                          <span className="qty">x{det.cantidad}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="card-section-dev">
                    {dev ? (
                      <div className="dev-alert">
                        <p>⚠️ <strong>Devolución:</strong> {dev.accion}</p>
                        <NavLink to={`/AdminEditarDevolucion/${pedido.id}`} className="link-edit-dev">
                          Gestionar Devolución
                        </NavLink>
                      </div>
                    ) : (
                      <p className="no-dev">✅ Sin solicitudes de devolución</p>
                    )}
                  </div>

                  <div className="card-section-actions">
                    <select
                      value={estadosTemp[pedido.id] || pedido.estado}
                      onChange={(e) => setEstadosTemp({ ...estadosTemp, [pedido.id]: e.target.value })}
                      className="select-admin"
                    >
                      {estadosPago.map((e) => (
                        <option key={e} value={e}>{e.replace("_", " ")}</option>
                      ))}
                    </select>
                    <button className="btn-update-admin" onClick={() => actualizarEstado(pedido.id)}>
                      Actualizar
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </main>
    </div>
  );
}